import { FC, cloneElement, Children } from 'react';
import { isUndefined } from 'lodash';

import { useContextSelector } from 'use-context-selector';

import { Button, ButtonProps } from '../../Button/Button';
import { ActionSheetContext } from '../ActionSheet.context';

type ActionSheetToggleProps = Omit<ButtonProps, 'onClick'>;

export const ActionSheetToggle: FC<ActionSheetToggleProps> = ({
  children,
  ...props
}) => {
  const id = useContextSelector(ActionSheetContext, ({ id }) => id);

  if (isUndefined(children) || typeof children === 'string') {
    return (
      <Button {...props} id={id}>
        {children}
      </Button>
    );
  }

  return (
    <>
      {Children.toArray(children).map((item) => {
        const {
          // @ts-ignore
          props: { children, ...props },
        } = item;
        // @ts-ignore
        return cloneElement(item, { ...props, id }, children);
      })}
    </>
  );
};
